import { render, staticRenderFns } from "./ProjectAllocation.vue?vue&type=template&id=4c405504&scoped=true&"
import script from "./ProjectAllocation.vue?vue&type=script&lang=js&"
export * from "./ProjectAllocation.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAllocation.vue?vue&type=style&index=0&id=4c405504&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c405504",
  null
  
)

export default component.exports